import { Injectable } from '@angular/core'
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import * as moment from 'moment'

// Define custom service providing the months and weekdays translations
@Injectable()
export class LocalizedDatepickerI18n extends NgbDatepickerI18n {
  getWeekdayLabel(weekday: number): string {
    return moment.weekdaysShort()[weekday % 7]
  }

  getMonthShortName(month: number): string {
    return moment.months()[month - 1]
  }

  getMonthFullName(month: number): string {
    return this.getMonthShortName(month)
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`
  }
}
